import { useEffect, useState } from 'react';
import { ArrowPathIcon, ServerStackIcon } from '@heroicons/react/24/outline';
import { mandantLaufwerk, type MandantLaufwerk } from '../../api/client';
import { ConnectorZeile } from '../laufwerk/VerbindungKarte';
import { statusLabel, statusZeilen, STATUS_BADGE, zahl } from '../../utils/laufwerk';

/**
 * Betreiber-Konsole → Mandant → Laufwerk: Connector-Zustand und Zahlen je Status.
 * Bewusst nur Zahlen — keine Dateinamen, Pfade oder Inhalte der Firma.
 */
export default function LaufwerkBetreiber({ slug }: { slug: string }) {
  const [daten, setDaten] = useState<MandantLaufwerk | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);
  const [laedt, setLaedt] = useState(false);

  const laden = async () => {
    setLaedt(true);
    try { setDaten(await mandantLaufwerk(slug)); setFehler(null); }
    catch (e: any) { setDaten(null); setFehler(e?.message ?? String(e)); }
    finally { setLaedt(false); }
  };
  useEffect(() => {
    setDaten(null); void laden();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const zeilen = daten ? statusZeilen(daten.zahlen) : [];

  return (
    <div className="space-y-3 border-t border-gray-100 pt-3">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <div className="flex items-center gap-1.5 text-sm font-semibold text-ps-dark-800">
            <ServerStackIcon className="h-4 w-4 text-ps-dark-400" /> Laufwerk
          </div>
          <p className="text-xs text-ps-dark-400">Connector-Zustand und Anzahl Dateien je Status — keine Dateinamen oder Inhalte.</p>
        </div>
        <button onClick={() => void laden()} disabled={laedt} className="btn-ghost shrink-0 text-xs">
          <ArrowPathIcon className={`mr-1 inline h-3.5 w-3.5 ${laedt ? 'animate-spin' : ''}`} />
          {laedt ? 'Lade …' : 'Aktualisieren'}
        </button>
      </div>

      {fehler && <div className="rounded border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-700">Laufwerksstatus nicht verfügbar: {fehler}</div>}

      {daten && (
        <>
          {daten.connectors.length === 0 ? (
            <div className="rounded border border-dashed border-gray-200 px-3 py-4 text-center text-xs text-ps-dark-400">Kein Connector verbunden.</div>
          ) : (
            <ul className="space-y-2">{daten.connectors.map((c) => <ConnectorZeile key={c.id} c={c} />)}</ul>
          )}
          {zeilen.length === 0 ? (
            <div className="text-xs text-ps-dark-400">Noch keine Dateien im Index.</div>
          ) : (
            <div className="flex flex-wrap gap-2">
              {zeilen.map(({ status, n }) => (
                <span key={status} className={`badge ${STATUS_BADGE[status] ?? 'badge-neutral'} gap-1.5`}>
                  {statusLabel(status)} <span className="numerical font-semibold">{zahl(n)}</span>
                </span>
              ))}
              <span className="badge badge-neutral gap-1.5">Gesamt <span className="numerical font-semibold">{zahl(daten.gesamt)}</span></span>
            </div>
          )}
        </>
      )}
    </div>
  );
}
